import React from "react";
import "../styles/About.css";
import SoftwareDesign from "../assets/about/softwaredesign.svg";
import MobileDesign from "../assets/about/mobiledesign.svg";
import WebDesign from "../assets/about/webdesign.svg";
import WebDev from "../assets/about/webdev.svg";
import AI from "../assets/about/ai.svg";
import Figma from "../assets/about/figma.svg";
import PS from "../assets/about/ps.svg";
import Wordpress from "../assets/about/wordpress.svg";
import CDR from "../assets/about/cdr.svg";
import Mira from "../assets/about/mira.svg";
import XD from "../assets/about/xd.svg";
import Stars from "../assets/about/stars.svg";
import CE from "../assets/about/CE.svg";
import LC from "../assets/about/LC.svg";
import AC from "../assets/about/AC.svg";
import OZO from "../assets/about/OZO.svg";
import AJ from "../assets/about/AJ.svg";
import Intelinext from "../assets/about/intelinext.svg";

export default function About() {
  return (
    <div className="about">
      <div className="about-header">
        <p>
          I am a UI/UX designer with six years of experience in creating
          engaging and easy-to-use digital experiences.
        </p>
        <p>
          Throughout my career, I have worked on a wide range of projects across
          various industries, including tech startups, and SaaS platform. My
          approach is rooted in user-centered design principles, ensuring that
          every project. I undertake is informed by real user insights and data.
          I am skilled in the entire design process, from initial research and
          wire-framing to high-fidelity prototyping and usability testing.
        </p>
      </div>
      <div className="about-body">
        <h1>
          Actions I <span>Can Take</span>
        </h1>
        <div className="about-body-actions">
          <div className="about-body-action-box-division">
            <div className="about-body-action-box">
              <div className="about-body-action-box-image">
                <img src={SoftwareDesign} alt="Software Design" />
              </div>
              <div className="about-body-action-box-text">
                <h1>Software Design</h1>
                <p>
                  The goal of software design is to ensure that a system is
                  efficient, maintainable, scalable, and meets the requirements
                  of stakeholders.
                </p>
              </div>
            </div>
            <div className="about-body-action-box">
              <div className="about-body-action-box-image">
                <img src={MobileDesign} alt="Mobile Apps Design" />
              </div>
              <div className="about-body-action-box-text">
                <h1>Mobile Apps Design</h1>
                <p>
                  Mobile app design is all about creating a seamless and
                  engaging user experience on smartphones and tablets.
                </p>
              </div>
            </div>
          </div>
          <div className="about-body-action-box-division">
            <div className="about-body-action-box">
              <div className="about-body-action-box-image">
                <img src={WebDesign} alt="Web Design" />
              </div>
              <div className="about-body-action-box-text">
                <h1>Web Design</h1>
                <p>
                  Web design involves creating the visual and functional aspects
                  of websites. It includes layout, content, structure.
                </p>
              </div>
            </div>
            <div className="about-body-action-box">
              <div className="about-body-action-box-image">
                <img src={WebDev} alt="Web Development" />
              </div>
              <div className="about-body-action-box-text">
                <h1>Web Development</h1>
                <p>
                  WordPress is one of the most popular platforms for building
                  websites due to its ease of use, flexibility, and vast
                  community support
                </p>
              </div>
            </div>
          </div>
        </div>

        <h1>
          My <span>Stacks</span>
        </h1>
        <div className="about-body-stacks-container">
          <div className="about-body-stacks">
            <img src={AI} alt="AI" />
            <img src={Figma} alt="Figma" />
            <img src={PS} alt="PS" />
            <img src={Wordpress} alt="Wordpress" />
            <img src={CDR} alt="CDR" />
            <img src={Mira} alt="Mira" />
            <img src={XD} alt="XD" />
          </div>
        </div>

        <h1>
          Projects I <span>Contributed To</span>
        </h1>
        <div className="about-body-projects-container">
          <div className="about-body-projects">
            <img src={CE} alt="CE" />
            <img src={LC} alt="LC" />
            <img src={AC} alt="AC" />
            <img src={OZO} alt="OZO" />
            <img src={AJ} alt="AJ" />
            <img src={Intelinext} alt="Intelinext" />
          </div>
        </div>

        <h1>
          Testimonials <span>From Clients</span>
        </h1>
        <div className="about-body-testimonial">
          <div className="about-body-testimonial-box">
            <div class="initial-circle">AB</div>
            <img src={Stars} alt="Stars" />
            <p>
              The design is modern, user-friendly, and perfectly aligned with
              our brand. Since launching, we’ve seen significant improvements in
              traffic and engagement. Highly recommend his professional skills.{" "}
            </p>
            <h1>Aqeel Azeem</h1>
            <p>MANAGING DIRECTOR</p>
          </div>
          <div className="about-body-testimonial-box">
            <div class="initial-circle">IN</div>
            <img src={Stars} alt="Stars" />
            <p>
              The website is sleek, user-centric, and truly reflects our brand's
              identity. It has been an absolute pleasure working with you! Your
              attention to detail and creativity have exceeded our expectations.
            </p>
            <h1>Junaid Muhammad</h1>
            <p>MANAGING DIRECTOR</p>
          </div>
          <div className="about-body-testimonial-box">
            <div class="initial-circle">AJ</div>
            <img src={Stars} alt="Stars" />
            <p>
              The app is visually stunning, intuitive to navigate, and perfectly
              tailored to our business needs. He took our vision and transformed
              it into a sleek, modern design that exceeded all our expectations.
            </p>
            <h1>D. Ajay Kumar</h1>
            <p>MANAGING DIRECTOR</p>
          </div>
        </div>
      </div>
    </div>
  );
}
